import { Button, Col, Row } from "reactstrap";
import { AcceptRejectSubmitHandler } from "../../../Pages/Private/Admin/LeaveMangement/AddLeave/AddLeaveMethods/AddLeaveModalMethods";

const Transfer_Modal = (props: any) => {
    // Determine button text based on approval level
    const getButtonText = () => {
        if (props?.blockVerify === 3) {
            return "Block Approve";
        } else if (props?.blockVerify === 1) {
            return "District Approve";
        }
        return "Verify";
    };
console.log("props",props);
    return (
        <>
            <div className="form-wrap">
                <Row className="gy-4">
                    <Col lg={12}>
                        <div className="modal-warning-text-wrap">
                            <div className="warning-img-wrap">
                                <img src="/images/delete-warning.svg" alt="warning-icon" />
                            </div>
                            {props?.seat != "notavailable" && <h5 className="modal-warning-title">Are you sure ?</h5>}
                            <small className="sub-text">
                                {" "}
                                {
                                    props?.seat == "notavailable"
                                        ? "No seats available please move a member from this office to transit for making seat available"
                                        : props?.type === "change"
                                            ? " Do you really want to accept the transfer"
                                            : props?.status === 2
                                                ? "Do you really want to Publish"
                                                : "Do you really want to Delete"
                                }
                                .
                            </small>
                        </div>
                    </Col>

                    <Col lg={12}>
                        <div className="submit-btn-wrap centered">
                            <Button
                                color={"danger"}
                                outline
                                className="sm"
                                onClick={() => props?.setModal(false)}
                            >
                                Cancel
                            </Button>

                            {props?.type === "change" && props?.seat == "available" ? (
                                <>
                                    <Button
                                        color={"primary"}
                                        className="sm"
                                        onClick={() => {
                                            AcceptRejectSubmitHandler(
                                                props?.setModal,
                                                props?.Refetch,
                                                props?.delete_id,
                                                "2",
                                                props?.blockVerify,
                                                props?.from_transfer_req,
                                            );
                                            // Note: Member update is now handled automatically by backend
                                            // when both block and district approvals are complete
                                        }}
                                    >
                                        {getButtonText()}
                                    </Button>
                                </>
                            )
                                : props?.seat != "notavailable" ?
                                    (
                                        <Button
                                            color={"danger"}
                                            className="sm"
                                            onClick={() => {
                                                props.onDeleteClick(props.delete_id, props?.refetch);
                                                props?.setModal(false);
                                            }}
                                        >
                                            Delete
                                        </Button>
                                    ) : ""}
                        </div>
                    </Col>
                </Row>
            </div >
        </>
    );
};

export default Transfer_Modal;
